export const isLoadingSelector = ideaConceptState => ideaConceptState.loading;

export const isErrorSelector = ideaConceptState => ideaConceptState.error;

export const dropById = id => arr => arr.filter(item => item !== id);
